import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from './safe.pipe';
import { IvaPipe } from './iva.pipe';
import { SeguridadUSerPipe } from './seguridad-user.pipe';
const pipes = [
  SafePipe,IvaPipe,SeguridadUSerPipe
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule { }
